module.exports = __webpack_public_path__ + "static/media/babel-2-right.862745d2.webp";